module.exports = __webpack_public_path__ + "static/media/23.96fd77bf.jpg";